/* eslint-disable no-restricted-globals */
import styles from './fifth.module.css';
import FullSize from '../../components/full-size';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getNextLevelUrl, isLevelAllowed, markLevelCompleted } from '../../helper';
import AnswerForm from '../../components/answer-form';
import HintBox from '../../components/hint-box';

function Fifth() {
  const LEVEL = 5;
  const navigate = useNavigate();
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (!isLevelAllowed(LEVEL)) {
      navigate("/cheating");
    }
  }, [navigate])

  const onSubmit = (answer: string) => {
    if (answer === "1297" || answer === "9898") {
      markLevelCompleted(LEVEL);
      navigate(getNextLevelUrl(LEVEL));
    } else {
      setShake(true);
    }
  }

  return (
    <FullSize bgColor="transparent">
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Level 5</h1>
        <AnswerForm type="number" onSubmit={onSubmit} shake={shake} setShake={setShake} />
      </div>
      <HintBox hintText="Svaret finns i konsten här i stugorna." />
    </FullSize>
  );
}

export default Fifth;